import { useRef, useState, type DragEvent } from 'react';

/** Area di caricamento: clic o trascinamento di un file (o di più file con `multiple` e `onFiles`). */
export function FileDrop({
  onFile,
  onFiles,
  multiple = false,
  disabled,
  label = multiple ? 'Trascina qui i file o fai clic per sceglierli' : 'Trascina qui un file o fai clic per sceglierlo',
  accept = '.csv,.xlsx,.pdf,.txt',
  hint = 'CSV, Excel (.xlsx), PDF',
}: {
  onFile?: (f: File) => void;
  onFiles?: (fs: File[]) => void;
  multiple?: boolean;
  disabled?: boolean;
  label?: string;
  accept?: string;
  hint?: string;
}) {
  const input = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const take = (list: FileList | null | undefined) => {
    const files = [...(list ?? [])];
    if (!files.length || disabled) return;
    if (onFiles) onFiles(multiple ? files : files.slice(0, 1));
    else onFile?.(files[0]!);
  };
  const drop = (e: DragEvent) => {
    e.preventDefault();
    setOver(false);
    take(e.dataTransfer.files);
  };
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => input.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={drop}
      className={`w-full rounded-xl border-2 border-dashed px-4 py-6 text-sm text-ink/60 transition ${over ? 'border-accent bg-accent/5' : 'border-black/15 hover:border-accent/60'} disabled:opacity-50`}
    >
      {label}
      <span className="mt-1 block text-xs text-ink/40">{hint}</span>
      <input
        ref={input}
        type="file"
        multiple={multiple}
        accept={accept === '*' ? undefined : accept}
        className="hidden"
        onChange={(e) => {
          take(e.target.files);
          e.target.value = '';
        }}
      />
    </button>
  );
}
